import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bienvenido/a de nuevo");
      const redirect = loc.state?.from || (u.role === "admin" ? "/admin" : "/account");
      nav(redirect);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="pt-28 min-h-screen flex">
      <div className="hidden md:block w-1/2 relative">
        <img src="https://images.unsplash.com/photo-1723734820800-89bc7309acf3?w=1200&q=85" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-carbon/40 to-carbon" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="overline mb-3">M&H Lumora</p>
          <h2 className="font-heading text-4xl text-ivory leading-tight">Su universo<br /><span className="italic text-gold">en privado</span></h2>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <p className="overline mb-3">Acceso</p>
          <h1 className="font-heading text-4xl text-ivory mb-10">Iniciar sesión</h1>
          <form onSubmit={submit} className="space-y-6">
            <div>
              <label className="luxe-label">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="luxe-input" />
            </div>
            <div>
              <label className="luxe-label">Contraseña</label>
              <input data-testid="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="luxe-input" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-gold w-full disabled:opacity-50">
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>
          <p className="text-center mt-8 text-sm text-ivory/60">
            ¿Aún no tiene cuenta? <Link to="/register" className="text-gold link-underline">Crear cuenta</Link>
          </p>
          <div className="mt-12 pt-6 border-t border-smoke text-xs text-ivory/40 space-y-1">
            <p className="overline">Cuentas de prueba</p>
            <p>Admin: admin@luxe.com / Admin123!</p>
            <p>Cliente: cliente@luxe.com / Cliente123!</p>
          </div>
        </div>
      </div>
    </div>
  );
}
